const _key_ = 'post-cache'
const maxReq = 20

class Cache {
  setCache (url, data) {
    const caches = this.getCaches()
    const exist = caches.find(_ => _.url === url)
    if (exist) {
      exist.data = data
    } else {
      caches.push({
        url,
        data
      })
    }
    if (caches.length > maxReq) {
      caches.shift()
    }
    window.localStorage.setItem(_key_, JSON.stringify(caches))
  }

  getCaches () {
    const str = window.localStorage.getItem(_key_)
    if (str) {
      return JSON.parse(str)
    }
    return []
  }

  getCacheByPath (url) {
    const caches = this.getCaches()
    const exist = caches.find(_ => _.url === url)
    if (exist) {
      return { ...exist.data }
    }
    return {}
  }

  removeCache (url) {
    const caches = this.getCache()
    const idx = caches.findIndex(_ => _.url === url)
    if (idx >= 0) {
      caches.splice(idx, 1)
      window.localStorage.setItem(JSON.stringify(caches))
    }
  }

  clearCache () {
    window.localStorage.removeItem(_key_)
  }
}
const cache = new Cache()
export default cache
